import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Button, Form, DatePicker, Select, Space, Avatar, Collapse, Progress, Tooltip } from 'antd';
import moment from 'moment';

import { taskType } from '~/helpers/lists';

import { reportCompletedWorkRequest } from '~/store/modules/reports/completedWork/actions';
import { userIndexRequest } from '~/store/modules/user/actions';

import { UserOutlined, ProjectOutlined, BugOutlined, SolutionOutlined } from '@ant-design/icons';
import { Container } from './styles';
import { FilterContent } from '../../Sprint/styles';

export default function CompletedWork() {
  const dispatch = useDispatch();

  const loading = useSelector(store => store.reportCompletedWork.loading);
  const result = useSelector(store => store.reportCompletedWork.result);
  const usersData = useSelector(store => store.user.list);

  const [users, setUsers] = useState([]);

  const [form] = Form.useForm();

  function onFinish(values) {
    const { startAt, endAt, userId } = values;

    let filters = [];

    filters.push({ startAt: moment(startAt).format('YYYY-MM-DD') });
    filters.push({ endAt: moment(endAt).format('YYYY-MM-DD') });

    if (userId) filters.push({ userId: userId });

    dispatch(reportCompletedWorkRequest(filters));
  }

  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });

    dispatch(userIndexRequest());
    //dispatch(reportCompletedWorkRequest());
  }, []);


  useMemo(() => {
    const result = [{
      id: undefined,
      name: 'Nenhum responsável',
      short: undefined,
      color: undefined,
      icon: <UserOutlined />
    }];

    const us = usersData?.map(u => {
      result.push({
        id: u.id,
        name: u.name,
        short: u.initials,
        color: u.color,
        icon: undefined
      });
    });

    setUsers(result);
  }, [usersData]);

  return (
    <Container>
      <h2>Relatório de Horas Trabalhadas</h2>

      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}>
        <Row gutter={8}>
          <Col xs={24} sm={12} md={6} lg={4}>
            <Form.Item
              label="Período de"
              name="startAt"
              rules={[{ required: true, message: 'Início é obrigatório' }]}
            >
              <DatePicker format="DD/MM/YYYY" placeholder="" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={6} lg={4}>
            <Form.Item
              label="Até"
              name="endAt"
              rules={[{ required: true, message: 'Término é obrigatório' }]}
            >
              <DatePicker format="DD/MM/YYYY" placeholder="" />
            </Form.Item>
          </Col>

          <Col xs={24} md={8} lg={8} style={{ marginBottom: -20 }}>
            <Form.Item
              label="Responsável"
              name="userId"
            >
              <Select>
                {users?.map(u => (
                  <Select.Option key={u.id} value={u.id}>
                    <Space>
                      <Avatar size="18" icon={u.icon} style={{ backgroundColor: u.color, verticalAlign: 'middle' }}>
                        {u.short}
                      </Avatar>
                      <span>{u.name}</span>
                    </Space>
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} md={4} lg={8}>
            <Form.Item
              noStyle
            >
              <FilterContent style={{ marginTop: 24, padding: 0 }}>
                <Button htmlType='submit' type='primary' loading={loading}>Gerar relatório</Button>
              </FilterContent>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      {(!loading && result && result.length > 0) && (
        <Collapse>
          {result.map(r => {
            const u = users?.find(a => a.id === r.userId) || { name: r.name };

            return (
              <Collapse.Panel header={(
                <Row>
                  <Col xs={24} md={20}>
                    <Space>
                      <Avatar size="18" icon={u.icon} style={{ backgroundColor: u.color, verticalAlign: 'middle' }}>
                        {u.short}
                      </Avatar>
                      <span>{r.name}</span>
                    </Space>
                  </Col>

                  <Col xs={24} md={4}>
                    <b>{r.completedWorkLabel}</b>
                  </Col>
                </Row>
              )} key={r.userId}>
                <Row>
                  <Col xs={24} className='icons-info'>
                    <Tooltip title="Projetos"><span className='icon-project'><ProjectOutlined /> {r.projectsCount}</span></Tooltip>
                    <Tooltip title="Tarefas"><span><SolutionOutlined style={{ color: taskType.find(a => Number(a.id) === 1)?.color }} /> {r.tasksCount}</span></Tooltip>
                    <Tooltip title="Bugs"><span><BugOutlined style={{ color: taskType.find(a => Number(a.id) === 2)?.color }} /> {r.bugsCount}</span></Tooltip>
                  </Col>
                </Row>

                {r.projects.map(p => (
                  <Row key={p.projectId}>
                    <Col xs={22} style={{ padding: '0.5rem' }}>
                      <span>{p.projectName}</span>
                      <Tooltip title={`Horas trabalhadas: ${p.completedWorkLabel}`}>
                        <Progress percent={p.percent} status="active" />
                      </Tooltip>
                    </Col>
                  </Row>
                ))}
              </Collapse.Panel>
            );
          })}
        </Collapse>
      )}
    </Container>
  );
}
